<template>
  <SoftwareCenter />
</template>

<script setup lang="ts">
import type { ITechnicalComponent } from '~~/lib/ContentfulService';
import SoftwareCenter from '~/components/downloads/software/SoftwareCenter.vue';

interface Props {
  item: ITechnicalComponent;
}

defineProps<Props>();
</script>
